import styled, { css } from 'styled-components';

import { utilService } from '../../../services/util-service';

interface MapOverlayProps {
  users?: any;
  phone?: string;
  role?: string;
  location?: any;
  locations?: any;
}

const COLOR = {
  R: css`
    background-color: rgba(0, 134, 255, 0.8);
  `,
  V: css`
    background-color: rgba(230, 53, 40, 0.8);
  `,
};

const TOP = {
  R: css`
    border-top: 4vh solid rgba(0, 134, 255, 0.8);
  `,
  V: css`
    border-top: 4vh solid rgba(230, 53, 40, 0.8);
  `,
};

const MapOverlay = ({ users, phone, role, location, locations }: MapOverlayProps) => {
  const elapsedMinutes = (): any => {
    const selected = locations.find((element) => element.phone === phone);
    if (selected === undefined) {
      return '0';
    }
    const timeDiff = new Date(location.saveTime).getTime() - new Date(selected.loc[0].saveTime).getTime();
    return Object.is(timeDiff, NaN) || timeDiff < 0 ? '0' : Math.floor(timeDiff / 1000 / 60);
  };

  const findInviteTime = (data, targetPhone) => {
    if (!data || !Array.isArray(data.rDatas) || data.rDatas.length === 0) {
      return null;
    }
    const user = data.rDatas.find((item) => item.phone === targetPhone);
    return user ? `${user.inviteTime.split(' ')[1]} ${user.duration ?? ''}` : null;
  };

  const findVInviteTime = (data, targetPhone) => {
    if (!data || !Array.isArray(data.vDatas) || data.vDatas.length === 0) {
      return null;
    }
    const user = data.vDatas.find((item) => item.phone === targetPhone);
    return user ? `${user.inviteTime.split(' ')[1]}` : null;
  };

  return (
    <StyledMapOverlayGpxInfo color={role}>
      <ul className="popup-content">
        <li>{utilService.isMobileFormat(phone)}</li>
        {role === 'R' ? (
          <li>동원수락 : {findInviteTime(users, phone)}분 이내 도착예정</li>
        ) : (
          <li>위치요청 : {findVInviteTime(users, phone)}</li>
        )}
        <li>
          위치전송 : {utilService.getTime(location.saveTime)} ({elapsedMinutes()}분 경과)
        </li>
        <li>
          위치좌표 : {utilService.convertToDms(location.lat, false)} {utilService.convertToDms(location.lng, true)}
        </li>
      </ul>
      <div className="popup-bottom"></div>
    </StyledMapOverlayGpxInfo>
  );
};

const StyledMapOverlayGpxInfo = styled.div`
  // position: absolute;
  ${(props) => props.color && COLOR[props.color]}
  // background-color: #4f4f4f;
  color: #fff;
  width: max-content;
  // border-top-left-radius: 15px;
  // border-bottom-right-radius: 15px;
  border-radius: 10px;
  pointer-events: none;
  padding: 1.3vh;
  // top: -19vh;
  // left: -8vw;

  .popup-content {
    position: relative;
    list-style: none;
    margin: unset;
    padding: 0 0;
    font: 14px 'kopubM';
    pointer-events: auto;
  }
  .popup-content > li {
    padding: 4px 0;
    padding-right: 1vw;
  }

  .popup-bottom {
    width: 0;
    height: 0;
    position: absolute;
    left: 42%;
    top: 100%;
    ${(props) => props.color && TOP[props.color]}
    // border-top: 5vh solid #4f4f4f;
    border-left: 2vh solid transparent;
    border-right: 2vh solid transparent;
  }
`;

export default MapOverlay;
